import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { Carousel } from 'react-responsive-carousel'
import Loader from '../../UI/Loader'
import GuruProfileAbout from '../GuruProfileAbout'
import GuruProfileServices from '../GuruProfileServices'
import Reviews from '../Reviews'
import ChooseDatesModal from './ChooseDatesModal'
import 'react-responsive-carousel/lib/styles/carousel.css'
import USER_FULL_INFO from './../../../graphql/UserByID.graphql'
import moment from 'moment'
import _ from 'lodash'
import get from 'lodash/get'


class FinishPage extends React.Component {
  state = {
    isOpen: false,
    startDate: null,
    endDate: null,
    coutOfTripDays: null,
    optimalPlan: null,
    selectedPlan: null,
    flexDays: '',
    options: []
  }

  componentWillMount() {
    if (!this.props.data.loading && !this.props.data.user[0].plannerProfile) {
      this.props.history.push('/create-guru-profile/description')
    }
  }

  getCoutnTripDays = () => {
    const coutOfTripDays =
      this.state.endDate && this.state.startDate && moment(this.state.endDate).diff(moment(this.state.startDate), 'days')
    this.setState({ coutOfTripDays: coutOfTripDays }, () => this.getOptimalPlan())
  }

  getCoutnFlexDays = () => {
    this.setState({ coutOfTripDays: this.state.flexDays }, () => this.getOptimalPlan())
  }

  getOptimalPlan = () => {
    const { coutOfTripDays } = this.state
    const arr = []
    if (Number(coutOfTripDays) % 7 === 0) {
      arr.push('PayOneWeekPeriod')
    }
    if (Number(coutOfTripDays) % 14 === 0) {
      arr.push('PayTwoWeekPeriod')
    }
    if (Number(coutOfTripDays) % 21 === 0) {
      arr.push('PayThreeWeekPeriod')
    }
    if (Number(coutOfTripDays) >= 28 && Number(coutOfTripDays) <= 31) {
      arr.push('PayForMonth')
    }
    if (Number(coutOfTripDays) > 31) {
      arr.push('PayForMoreThanMonth')
    }
    arr.push('PayPerDay')
    this.setState(
      {
        optimalPlan: arr
      },
      this.fillMapOptions
    )
  }

  /*eslint no-unreachable: "off"*/
  calculatePrice = arg => {
    switch (arg.paymentStructure) {
      case 'PayPerDay':
        console.log('arg price', arg.price)
        return arg.price * this.state.coutOfTripDays
        break
      case 'PayOneWeekPeriod':
        console.log('arg price', arg.price)
        return arg.price * this.state.coutOfTripDays / 7
        break
      case 'PayTwoWeekPeriod':
        console.log('arg price', arg.price)
        return arg.price * this.state.coutOfTripDays / 14
        break
      case 'PayThreeWeekPeriod':
        console.log('arg price', arg.price)
        return arg.price * this.state.coutOfTripDays / 21
        break
      case 'PayForMonth':
        console.log('arg price', arg.price)
        return arg.price
        break
      case 'PayForMoreThanMonth':
        console.log('arg price', arg.price)
        return arg.price
        break
      default:
        break
    }
  }

  sortPlans = (a, b) => {
    return this.calculatePrice(a) - this.calculatePrice(b)
  }

  handleSubmit = () => {
    if (!this.state.selectedPlan) {
      this.props.history.push('/booking-steps/' + this.props.data.user[0].id, {
        plan: this.state.options[0],
        coutOfTripDays: this.state.coutOfTripDays,
        currency: this.props.data.user[0].plannerProfile.currency
      })
    } else {
      this.props.history.push('/booking-steps/' + this.props.data.user[0].id, {
        plan: this.state.selectedPlan,
        coutOfTripDays: this.state.coutOfTripDays,
        currency: this.props.data.user[0].plannerProfile.currency
      })
    }
  }

  getPaymentCategoryName = paymentCategory => {
    switch (paymentCategory) {
      case 'PayOneWeekPeriod':
        return 'Pay One Week Period'
        break
      case 'PayTwoWeekPeriod':
        return 'Pay Two Week Period'
        break
      case 'PayThreeWeekPeriod':
        return 'Pay Three Week Period'
        break
      case 'PayForMonth':
        return 'Pay For Month'
        break
      case 'PayPerDay':
        return 'Pay Per Day'
        break
      default:
        return paymentCategory
    }
  }

  fillMapOptions = () => {
    // const locationData = 'China'
    const locationData = null
    this.state.endDate &&
      this.setState({
        options:
          this.props.data &&
          this.props.data.user &&
          this.props.data.user[0].plannerProfile &&
          this.props.data.user[0].plannerProfile.planOffers &&
          this.props.data.user[0].plannerProfile.planOffers.length &&
          this.props.data.user[0].plannerProfile.planOffers
            .filter(plan => {
              if (locationData) {
                return (
                  plan.location.country === locationData &&
                  this.state.optimalPlan.includes(plan.paymentStructure) &&
                  plan.status !== 'Deleted'
                )
              } else {
                return this.state.optimalPlan.includes(plan.paymentStructure) && plan.status !== 'Deleted'
              }
            })
            .sort(this.sortPlans)
      })
  }

  render() {
    const { t } = this.props
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { user } = this.props.data
    return (
      <div>
        <div className="steps-screen__guru-profile-container faded-container">
          <div className="guru-profile ">
            <div className="guru-profile__left-column">
              <GuruProfileAbout user={user} t={t} showChatBox={null} />
              <GuruProfileServices user={user} />
              <Reviews user={user} />
            </div>
            <div className="guru-profile__right-column" style={{ maxWidth: 450 }}>
              {this.props.data &&
              this.props.data.user[0] &&
              this.props.data.user[0].plannerProfile &&
              this.props.data.user[0].plannerProfile.photos &&
              this.props.data.user[0].plannerProfile.photos.length ? (
                <div className="finishPage__carousel">
                  <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
                    {this.props.data.user[0].plannerProfile.photos.map((photo, index) => (
                      <div className="carouselPhoto" key={index}>
                        <img src={photo.url} alt="" />
                      </div>
                    ))}
                  </Carousel>
                </div>
              ) : (
                <div />
              )}
              {this.state.optimalPlan && (
                <select
                  id="finish-select"
                  className="guru-profile__select-booking-info"
                  onChange={e =>
                    this.setState({
                      selectedPlan: this.state.options[e.target.selectedIndex]
                    })
                  }
                >
                  {this.state.options.length > 0 &&
                    _.uniqBy(this.state.options, e => e.location.country).map((plan, index) => {
                      return (
                        <option id={index} key={index}>{`${plan.location.country}, ${this.props.data.user[0].plannerProfile.currency}, ${
                          plan.price
                        }, ${this.getPaymentCategoryName(plan.paymentStructure)}`}</option>
                      )
                    })}
                </select>
              )}
              {this.state.flexDays !== '' &&
                this.state.flexDays !== '0' && (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>
                    {this.state.flexDays} day(s)
                  </button>
                )}
              {(this.state.flexDays === '' || this.state.flexDays === '0') &&
                (this.state.startDate && this.state.endDate && this.state.flexDays !== '0' ? (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>{`${moment(
                    this.state.startDate
                  ).format('DD.MM.YYYY')} - ${moment(this.state.endDate).format('DD.MM.YYYY')}`}</button>
                ) : (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>
                    Choose your dates
                  </button>
                ))}
              {((this.state.startDate && this.state.endDate) || this.state.flexDays >= 1) && (
                <button className="btn btn-sm btn-primary btn-danger" onClick={this.handleSubmit}>
                  Start your booking
                </button>
              )}
            </div>
          </div>
          <ChooseDatesModal
            isOpen={this.state.isOpen}
            onClose={() => this.setState({ isOpen: false })}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={({ startDate, endDate }) => {
              this.setState({ startDate, endDate }, () => this.getCoutnTripDays())
            }}
            displayFormat={'MMM DD'}
            flexDays={this.state.flexDays}
            onFlexChange={e => this.setState({ flexDays: e.target.value }, () => this.getCoutnFlexDays())}
            clearFlex={() => this.setState({ flexDays: '', startDate: null, endDate: null })}
          />
        </div>
      </div>
    )
  }
}

export default compose(
  translate('guru'),
  graphql(USER_FULL_INFO, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })
)(FinishPage)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/FinishPage.jsx